module.exports = __webpack_public_path__ + "img/bg-support-optimized.590a3c42.jpg";